import { useQueryParams } from "@certn/api";
import {
  ButtonGroup,
  Container,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { TextField } from "@certn/cascadia-react/components/inputs/text-field/TextField";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { CopyLinkButton } from "../../../components/copy-link-button/CopyLinkButton";

export function ApplyLinkCreatedModal() {
  const { t } = useTranslation();
  const { params, clearParams } = useQueryParams();

  return (
    <Modal isOpen={!!params.apply_link} testID="apply-link-created-modal">
      <Dialog>
        <DialogHeader onClose={clearParams}>
          {t("Apply link created")}
        </DialogHeader>
        <DialogContent>
          <Container layout="applicant/narrow">
            <Text style="global/body-primary">
              {t(
                "Your apply link has been created. You can access and manage this link from settings."
              )}
            </Text>
            <span className={css(styles.urlFieldContainer)}>
              <TextField
                label={t("Apply link URL")}
                value={params.apply_link as string}
                isRequired
                isDisabled
                testID="apply-link-url"
                type="url"
                className={styles.urlField}
              />
              <CopyLinkButton url={params.apply_link as string} />
            </span>
          </Container>
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <PrimaryButton
              size="medium"
              onPress={clearParams}
              testID="close-modal-button"
            >
              {t("Close")}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}

const styles = {
  urlFieldContainer: css({
    display: "flex",
    flexDirection: "row",
    gap: "var(--space-2)",
    alignItems: "end",
  }),
  urlField: css({
    flex: 1,
    width: "100%",
  }),
};
